import { useState } from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration'
import _ from 'lodash';

import { SecondsFormat, TimeFormat } from '../../shared/TimeFormat';

import { BoardData } from './Board';
import { Tag } from './Tag';

import cls from './Card.module.scss';
dayjs.extend(duration)

interface ICard {
  data: BoardData;
  small?: boolean;
  onCardOpen?: () => void;
  onCardDrag?: () => void;
  onCardDrop?: () => void;
  onCardPreview?: () => void;
}

export const Card = ({ data, small, onCardOpen, onCardDrag }: ICard) => {

  const onMouseDown = () => {
    console.log('pressed');
  };

  const [isDragging, setIsDragging] = useState<boolean>(false);

  const getDeadlineColor = (deadline: dayjs.Dayjs): string => {
    const today = dayjs().startOf('day');
    const tomorrow = dayjs().add(1, 'day').startOf('day');
    const deadlineDate = deadline.startOf('day');

    if (deadlineDate.isBefore(today) || deadlineDate.isSame(today)) {
      return '#ff4d4f'; // красный для сегодня или прошедшего срока
    }
    if (deadlineDate.isSame(tomorrow)) {
      return '#faad14'; // желтый для завтра
    }
    return '#333333'; // серый по умолчанию
  };

  function handleDragStart(e: any) {
    setIsDragging(true);
    const data = JSON.stringify({ type: 'card' });
    e.dataTransfer.setData('text/plain', data);
    // if (onCardDrag) {onCardDrag()}
    // console.log('start', e);
  }

  function handleDragEnd(e: any) {
    setIsDragging(false);
    e.dataTransfer.clearData();
    // if (onCardDrop) {onCardDrop()}
    // console.log('end', e);
  }

  return (
    <div className={cn([cls.card, small && cls.small, isDragging && cls.dragging])}
         style={{borderColor: data.client && data.client.color}}
         onClick={onCardOpen}
         onDrag={onCardDrag}
         onDragStart={handleDragStart}
         onMouseDown={onMouseDown}
         onDragEnd={handleDragEnd}
         draggable
    >
      {data.coverUrl && <img src={data.coverUrl} alt={data.name} className={cls.cover}/>}
      <div className={cls.title}>{data.name}</div>
      {!small &&
      <div className={cls.tags}>
        {data.client && <Tag data={data.client} />}
        {data.group && <Tag data={data.group} />}
        {_.map(data.users, (user, index) => (<Tag key={index} data={user} />))}
        {data.deadline && <Tag data={{ id: 'deadline', name: data.deadline.format('DD.MM.YYYY'), color: getDeadlineColor(data.deadline) }} />}
        {data.reportsMinutes > 0 && <Tag data={{ id: 'report', name: `✅ ${TimeFormat(data.reportsMinutes)}`, color: '#333333' }} />}
        {data.timersSeconds > 0 && <Tag data={{ id: 'timer', name: `🕑 ${SecondsFormat(data.timersSeconds)}`, color: '#333333' }} />}
      </div>
      }
    </div>
  );
}